export default __webpack_public_path__ + "static/media/ProfilePictureLinkedIn.09ab6abf.jpeg";